angular.module('dnecom')
    .controller('UrlMappingSettingsController', ["$scope", "$http", "wizardModal", "notifications", function ($scope, $http, wizardModal, notifications) {
        var storeDomain = TemplateData.value('frontendDomain');

        $scope.urlMappings = TemplateData.value('urlMappings');
        $scope.products = TemplateData.value('products');

        $scope.settings = {
            'showMappings' : 'all'
        };

        $scope.savingUrls = false;
        $scope.selectedMapping = null;

        $scope.searchProducts = function ($search) {
            $http.get(
                Routing.generate('api_products_get_by_query', {
                    store: $scope.store.id,
                }),
                {
                    params: {query: $search.search},
                }
            ).then(function(response) {
                $scope.products = response.data.products;
            }, function(response) {
                notifications.danger('Request error.');
            });
        }

        $scope.openUrlsModal = function() {
            var urlsModal = wizardModal.open({
                templateUrl: 'urlMappingModal.html',
                controller: 'UrlMappingModalController',
                size: ''
            });

            urlsModal.result.then(function(urls) {
                $scope.savingUrls = true;

                $http.post(
                    Routing.generate('stores_settings_add_url_mappings', {
                        id: $scope.store.id
                    }),
                    {
                        'urls' : urls
                    }
                ).then(function(response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message || 'Unknown error.');
                        return;
                    }

                    $scope.urlMappings = response.data.urlMappings;

                    notifications.success('URLs saved successfully.');
                }, function(response) {
                    notifications.danger('Request error.');
                }).then(function() {
                    $scope.savingUrls = false;
                });

            });
        };

        $scope.getFullUrl = function(url) {
            return 'http://' + storeDomain + '/' + url;
        };

        $scope.isVisible = function(mapping) {
            if ($scope.settings.showMappings == 'all') {
                return true;
            }

            return (
                ($scope.settings.showMappings == 'assigned' && mapping.product)
                || ($scope.settings.showMappings == 'unassigned' && !mapping.product)
            );
        };

        $scope.selectMapping = function(mapping) {
            $scope.selectedMapping = mapping;
        };

        $scope.save = function(mapping) {
            $http.post(
                Routing.generate('stores_settings_update_url_mapping', {
                    id: $scope.store.id,
                }),
                {
                    mappingId: mapping.id,
                    productId: mapping.product.id
                }
            ).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Unknown error.');
                    return;
                }

                notifications.success('Mapping updated successfully.');
            }, function(response) {
                notifications.danger('Request error.');
            });
        };

        $scope.areMappingsChecked = function() {
            var checked = false;

            angular.forEach($scope.urlMappings, function(mapping) {
                if (mapping.checked) {
                    checked = true;
                }
            });

            return checked;
        };

        $scope.deleteCheckedMappings = function() {
            var mappingIds = [];

            angular.forEach($scope.urlMappings, function(mapping) {
                if (mapping.checked) {
                    mappingIds.push(mapping.id);
                }
            });

            $http.post(
                Routing.generate('stores_settings_delete_url_mappings', {
                    id: $scope.store.id,
                }),
                {
                    mappingIds: mappingIds
                }
            ).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Unknown error.');
                    return;
                }

                if ($scope.selectedMapping && $scope.selectedMapping.checked) {
                    $scope.selectedMapping = null;
                }

                $scope.urlMappings = response.data.urlMappings;

                notifications.success('Mappings deleted successfully.');
            }, function(response) {
                notifications.danger('Request error.');
            });
        };
    }]);
